import { render, staticRenderFns } from "./EmailSent.vue?vue&type=template&id=87fcdc58&scoped=true&"
import script from "./EmailSent.vue?vue&type=script&lang=ts&"
export * from "./EmailSent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fcdc58",
  null
  
)

export default component.exports